import type { FC } from 'react';
import { OrganizationsTable } from './OrganizationsTable';

export const OrganizationsPage: FC = () => {
  return (
    <>
      {/* <OrganizationSearchForm /> */}
      <OrganizationsTable />
    </>
  );
};
